/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type ComponentType, type HTMLAttributes, type ReactNode } from 'react';

interface ThirdPartyComponentProps extends HTMLAttributes<HTMLElement> {
  [key: string]: any;
  component: ComponentType<any>;
  children?: ReactNode;
}

const ReactEDSWrapper: React.FC<ThirdPartyComponentProps> = ({ component: Component, ...props }) => {
  return <Component {...props} />;
};

export default ReactEDSWrapper;
